import { IFormItem } from '@components/Form/FormItem/FormItem';

export const controlCardConfig = [
  {
    label: 'Всего вакцинаций',
    key: 'total',
    type: 'text',
  },
  {
    label: 'Вакцинировано по графику',
    key: 'vaccinated',
    type: 'text',
  },
  {
    label: 'Находится в листе ожидания',
    key: 'inWaitingList',
    type: 'text',
  },
] as IFormItem[];
